var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-content" }, [
      _c("div", { staticClass: "main-content-inner" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "page-content" }, [
          _vm.loading
            ? _c("div", { attrs: { id: "loading" } }, [
                _c("div", { staticClass: "loadingMsg" })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _vm.errorMessage
                  ? _c("div", {
                      staticClass: "alert alert-danger",
                      domProps: { innerHTML: _vm._s(_vm.errorMessage) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.sucessStatus
                  ? _c("div", {
                      staticClass: "alert alert-success",
                      domProps: { innerHTML: _vm._s(_vm.sucessStatus) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("div", { staticClass: "clearfix" }, [
                    _c("div", { staticClass: "profile-info-row" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", { staticClass: "profile-info-value" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.oneloginLoginService.isValid,
                              expression: "oneloginLoginService.isValid"
                            }
                          ],
                          staticClass: "ace ace-switch ace-switch-4",
                          attrs: {
                            name: "switch-field-1",
                            disabled: !_vm.isFederatedLoginService,
                            type: "checkbox"
                          },
                          domProps: {
                            checked: Array.isArray(
                              _vm.oneloginLoginService.isValid
                            )
                              ? _vm._i(_vm.oneloginLoginService.isValid, null) >
                                -1
                              : _vm.oneloginLoginService.isValid
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.oneloginLoginService.isValid,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.oneloginLoginService.isValid = $$a.concat(
                                      [$$v]
                                    ))
                                } else {
                                  $$i > -1 &&
                                    (_vm.oneloginLoginService.isValid = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.$set(
                                  _vm.oneloginLoginService,
                                  "isValid",
                                  $$c
                                )
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "lbl" })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }, [
                    _c("div", { staticClass: "profile-info-row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "profile-info-name",
                          staticStyle: {
                            width: "156px",
                            "text-align": "left",
                            color: "#000",
                            "padding-left": "0px"
                          }
                        },
                        [_vm._v("メタデータURL")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "profile-info-value",
                          staticStyle: { width: "450px", border: "0px solid" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.oneloginLoginService.metadataUrl,
                                expression: "oneloginLoginService.metadataUrl"
                              }
                            ],
                            staticClass: "form-control input-sm",
                            attrs: {
                              type: "text",
                              disabled: !_vm.isFederatedLoginService,
                              placeholder: "メタデータURL"
                            },
                            domProps: {
                              value: _vm.oneloginLoginService.metadataUrl
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.oneloginLoginService,
                                  "metadataUrl",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      staticStyle: { "margin-bottom": "10px" }
                    },
                    [
                      _c("div", { staticClass: "profile-info-row" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _c("div", { staticClass: "profile-info-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.googleLoginService.isValid,
                                expression: "googleLoginService.isValid"
                              }
                            ],
                            staticClass: "ace ace-switch ace-switch-4",
                            attrs: {
                              name: "switch-field-1",
                              disabled: !_vm.isFederatedLoginService,
                              type: "checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(
                                _vm.googleLoginService.isValid
                              )
                                ? _vm._i(_vm.googleLoginService.isValid, null) >
                                  -1
                                : _vm.googleLoginService.isValid
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.googleLoginService.isValid,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.googleLoginService.isValid = $$a.concat(
                                        [$$v]
                                      ))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.googleLoginService.isValid = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.googleLoginService,
                                    "isValid",
                                    $$c
                                  )
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "lbl" })
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "clearfix",
                      staticStyle: { "margin-bottom": "10px" }
                    },
                    [
                      _c("div", { staticClass: "profile-info-row" }, [
                        _vm._m(4),
                        _vm._v(" "),
                        _c("div", { staticClass: "profile-info-value" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.appleIdLoginService.isValid,
                                expression: "appleIdLoginService.isValid"
                              }
                            ],
                            staticClass: "ace ace-switch ace-switch-4",
                            attrs: {
                              name: "switch-field-1",
                              disabled: !_vm.isFederatedLoginService,
                              type: "checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(
                                _vm.appleIdLoginService.isValid
                              )
                                ? _vm._i(
                                    _vm.appleIdLoginService.isValid,
                                    null
                                  ) > -1
                                : _vm.appleIdLoginService.isValid
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.appleIdLoginService.isValid,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.appleIdLoginService.isValid = $$a.concat(
                                        [$$v]
                                      ))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.appleIdLoginService.isValid = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.appleIdLoginService,
                                    "isValid",
                                    $$c
                                  )
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "lbl" })
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }, [
                    _c("div", { staticClass: "profile-info-row" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info",
                          attrs: { disabled: !_vm.allowSubmit, type: "button" },
                          on: {
                            click: function($event) {
                              _vm.saveConfig()
                            }
                          }
                        },
                        [_vm._v("設定を保存")]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _c("ul", { staticClass: "add_btn_list" }, [
      _c(
        "li",
        [
          _c(
            "router-link",
            {
              staticClass: "adduserExport",
              attrs: { to: { name: "relation-user-federated-login-service" } }
            },
            [_c("i", { staticClass: "ace-icon fa fa-users my-float" })]
          ),
          _vm._v(" "),
          _vm._m(6)
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "breadcrumbs ace-save-state",
        attrs: { id: "breadcrumbs" }
      },
      [
        _c("ul", { staticClass: "breadcrumb" }, [
          _c("li", [
            _c("i", { staticClass: "ace-icon fa fa-home home-icon" }),
            _vm._v(" "),
            _c("a", { attrs: { href: "#/" } }, [_vm._v("メインメニュー")])
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "active" }, [
            _vm._v("外部ログインサービス利用設定")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", [_vm._v("外部ログインサービス利用設定")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "profile-info-name",
        staticStyle: {
          width: "156px",
          "text-align": "left",
          color: "#000",
          "padding-left": "0px"
        }
      },
      [_c("b", [_vm._v("Onelogin でログイン")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "profile-info-name",
        staticStyle: {
          width: "156px",
          "text-align": "left",
          color: "#000",
          "padding-left": "0px"
        }
      },
      [_c("b", [_vm._v("Google でログイン")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "profile-info-name",
        staticStyle: {
          width: "156px",
          "text-align": "left",
          color: "#000",
          "padding-left": "0px"
        }
      },
      [_c("b", [_vm._v("AppleID でログイン")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "float",
        attrs: { href: "javascript:void(0)", id: "menu-share" }
      },
      [_c("i", { staticClass: "fa fa-plus my-float" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "label-container-export", staticStyle: { top: "180px" } },
      [
        _c("div", { staticClass: "label-text" }, [
          _vm._v("ログインユーザー登録")
        ]),
        _vm._v(" "),
        _c("i", { staticClass: "fa fa-play label-arrow" })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f8944d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f8944d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/login-service/ExternalLoginServiceSetting.vue
// module id = null
// module chunks = 